import React from "react";

import { Typography } from "../Typography";
import * as S from "./ExpandableRow.styles";

import { ExpandableRowProps } from "./types";

/**
 * ExpandableRow component provides expandable/collapsible content areas with customizable headers
 */
export const ExpandableRow = ({
  addNewTitle = "",
  children,
  closedStyle = false,
  customAction,
  disableBoxShadow = false,
  id,
  info,
  isNew = false,
  isOpen = false,
  onClick,
  openText = "View",
  noToggle = false,
  noViewButton = false,
  infoWidth,
  variant = "default"
}: ExpandableRowProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e?.preventDefault();
    if (onClick) {
      onClick();
    }
    if (!isNew && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const styleIsOpen = isOpen || (!closedStyle && noToggle);

  return (
    <S.Wrapper
      disableBoxShadow={disableBoxShadow}
      isOpen={styleIsOpen}
      variant={variant}
      id="settings-item"
    >
      <S.Layout variant={variant} isOpen={styleIsOpen}>
        {isNew ? (
          <div id={id}>
            <Typography.BodyText weight="bold">
              {addNewTitle || "Add"}
            </Typography.BodyText>
          </div>
        ) : (
          <S.Info width={infoWidth} id={id}>
            {info}
          </S.Info>
        )}

        {!noToggle && !noViewButton && (
          <S.ActionWrapper isOpen={styleIsOpen}>
            {isNew ? (
              <S.StyledButton
                id={`${id}-edit`}
                onClick={handleClick}
                variant="secondary"
              >
                <S.Close aria-label="button-close" />
              </S.StyledButton>
            ) : (
              <S.StyledButton
                id={`${id}-edit`}
                onClick={handleClick}
                variant="secondary"
              >
                <S.OpenText size="small" weight="semiBold" isOpen={styleIsOpen}>
                  {openText}
                </S.OpenText>{" "}
                <S.ChevronDown aria-label="chevron-button-down" />
              </S.StyledButton>
            )}
          </S.ActionWrapper>
        )}
        {customAction}
      </S.Layout>
      {children}
    </S.Wrapper>
  );
};
